import { useQueryClient, useMutation, } from "@tanstack/react-query";
import { useAuthApiClient } from "./useAuthApiClient";
import { QUERY_KEYS } from "./constants";
import useWalletAccount from "./useWalletAccount";
import { getBitcoinPublicKeyFromConnector } from "../utils/wagmi";
export function useLinkAccount(mutationOptions = {}) {
    const queryClient = useQueryClient();
    const authApiClient = useAuthApiClient();
    const { connector } = useWalletAccount();
    const { onSuccess: customOnSuccess, ...restMutationOptions } = mutationOptions;
    const { mutate, mutateAsync, ...rest } = useMutation({
        mutationFn: async (linkAccountMutationFnParameters) => {
            if (linkAccountMutationFnParameters.type === "wallet") {
                if (!connector) {
                    throw new Error("Connector not defined.");
                }
                const bitcoinPublicKey = await getBitcoinPublicKeyFromConnector(connector);
                // Linking bitcoin account
                if (bitcoinPublicKey) {
                    return authApiClient.linkAccount({
                        ...linkAccountMutationFnParameters,
                        bitcoinPublicKey,
                    });
                }
            }
            // Linking any other account like wallet evm address account or discord
            return authApiClient.linkAccount(linkAccountMutationFnParameters);
        },
        onSuccess: (data, variables, context) => {
            queryClient.resetQueries({ queryKey: [QUERY_KEYS.ACCOUNT] });
            if (customOnSuccess)
                customOnSuccess(data, variables, context);
        },
        ...restMutationOptions,
    });
    return { linkAccount: mutate, linkAccountAsync: mutateAsync, ...rest };
}
//# sourceMappingURL=useLinkAccount.js.map